<template>
  <div id="tac-admin-sales-printer__dashboard" class="tac-admin-sales-printer__dashboard">
    <ol class="breadcrumb">
      <li><a href="/admin">Admin</a></li>
      <li><a href="/admin/sales-order">Sales Order</a></li>
      <li><a href="/admin/sales-order/printer">Printer</a></li>
      <li class="active">Dashboard</li>
    </ol>
    <div class="page-header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-file-text-o"></span>
        Printer
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group form-group-sm" title="Order #">
            <label class="sr-only">Order #</label>
            <input type="text" class="form-control input-sm" v-model="filter.orderNumber" @keypress.enter="update" placeholder="Order #" />
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData" @click="update">Update</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || isFormClear" @click="clear">Clear</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" @click="reload" title="Refresh Page" :disabled="fetchingData"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- .page-header -->
    <div class="page-body">
      <div class="row">
        <div class="col-lg-8">
          <div class="tab-container tab-container--bordered tab-container--padded cm-record__tabs">
            <ul class="nav nav-tabs">
              <li @click="activateTab('tab-order')" :class="{active: isTabActive('tab-order')}"><a href="#tab-order" data-toggle="tab">Order</a></li>
              <li @click="activateTab('tab-invoice')" :class="{active: isTabActive('tab-invoice')}"><a href="#tab-invoice" data-toggle="tab">Invoice</a></li>
              <li @click="activateTab('tab-packing-list')" :class="{active: isTabActive('tab-packing-list')}"><a href="#tab-packing-list" data-toggle="tab">Packing List</a></li>
              <li @click="activateTab('tab-firearms-shipper')" :class="{active: isTabActive('tab-firearms-shipper')}"><a href="#tab-firearms-shipper" data-toggle="tab">Firearms Shipper</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane" id="tab-order" :class="{active: isTabActive('tab-order')}">
                <h3>Order</h3>
                <div class="form-group" v-if="orderNumber">
                  <a :href="`/admin/sales-order/printer/order/${orderNumber}?view=1`" class="btn btn-default">View</a>
                  <a :href="`/admin/sales-order/printer/order/${orderNumber}`" class="btn btn-default">Download</a>
                </div>
                <iframe v-if="orderNumber" :src="`/admin/sales-order/printer/order/${orderNumber}?view=1`" scrolling="no"></iframe>
              </div>
              <div class="tab-pane" id="tab-invoice" :class="{active: isTabActive('tab-invoice')}">
                <h3>Invoice</h3>
                <div class="form-group" v-if="orderNumber">
                  <a :href="`/admin/sales-order/printer/invoice/${orderNumber}?view=1`" class="btn btn-default">View</a>
                  <a :href="`/admin/sales-order/printer/invoice/${orderNumber}`" class="btn btn-default">Download</a>
                </div>
                <iframe v-if="orderNumber" :src="`/admin/sales-order/printer/invoice/${orderNumber}?view=1`" scrolling="no"></iframe>
              </div>
              <div class="tab-pane" id="tab-packing-list" :class="{active: isTabActive('tab-packing-list')}">
                <h3>Packing List</h3>
                <div class="form-group" v-if="orderNumber">
                  <a :href="`/admin/sales-order/printer/packing-list/${orderNumber}?view=1`" class="btn btn-default">View</a>
                  <a :href="`/admin/sales-order/printer/packing-list/${orderNumber}`" class="btn btn-default">Download</a>
                </div>
                <iframe v-if="orderNumber" :src="`/admin/sales-order/printer/packing-list/${orderNumber}?view=1`" scrolling="no"></iframe>
              </div>
              <div class="tab-pane" id="tab-firearms-shipper" :class="{active: isTabActive('tab-firearms-shipper')}">
                <h3>Firearms Shipper</h3>
                <div class="form-group" v-if="orderNumber">
                  <a :href="`/admin/sales-order/printer/firearms-shipper/${orderNumber}?view=1`" class="btn btn-default">View</a>
                  <a :href="`/admin/sales-order/printer/firearms-shipper/${orderNumber}`" class="btn btn-default">Download</a>
                </div>
                <iframe v-if="orderNumber" :src="`/admin/sales-order/printer/firearms-shipper/${orderNumber}?view=1`" scrolling="no"></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              Order Details
            </div>
            <div class="panel-body">
              <pre>{{ order }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div><!-- .page-body -->
  </div><!-- #tac-admin-sales-printer__dashboard -->
</template>

<script>
import _ from 'lodash'
// import moment from 'moment'
// import { mapState, mapGetters } from 'vuex'
import { mapGetters } from 'vuex'
// import { format as DateFormat } from '@/plugin/filter/date'
import ApiResponseMixin from '@/plugin/mixin/api-response'
// import Modal from '@/plugin/bootstrap/modal'
// import Money from '@/plugin/element/money'
// import MoneyMixin from '@/plugin/mixin/money'
// import NormalizePartNumber from '@/plugin/filter/normalize-part-number';
// import Pagination from '@/plugin/bootstrap/pagination';
import Popover from '@/plugin/directive/popover'
// import Toggle from '@/plugin/bootstrap/toggle';
import Tooltip from '@/plugin/directive/tooltip'

// const VENDOR_COMPANY_TAC = 'Tactical Innovations Inc.'
// const VENDOR_COMPANY_RSR = 'RSR Group Inc.'
// const VENDOR_COMPANY_SS  = 'Sports South Inc'

// const VENDOR_INITIAL_TAC = 'TAC'
// const VENDOR_INITIAL_RSR = 'RSR'
// const VENDOR_INITIAL_SS  = 'SS'

export default {
  data() {
    return {
      // layout: 'compact',
      // profitMarginTarget: VENDOR_INITIAL_TAC,
      // productLinkToUse: 'old',
      filter: {
        // vendor: 'all',
        // productId: null,
        // categoryId: null,
        orderNumber: null,
      },
      activeTab: null,
      // sorter: {
      //   profitAmount: null,
      //   profitPercentage: null,
      // },
      // activeRow: null,
      // enableMultipleLayout: false,
      // editPriceModal: {
      //   visible: false,
      //   item: null,
      //   part: null,
      //   form: {
      //     productId: null,
      //     retailPrice: null,
      //     salePrice: null,
      //     salePriceStatus: null,
      //     cashDiscount: null,
      //     cashDiscountStatus: null
      //   }
      // }
    }
  },
  created() {
    this.loadFilterFromRoute()
    // this.loadSorterFromRoute()
    // this.loadPaginationFromRoute()
    this.activateTab('tab-order')
    this.fetchOrder()
    // this.fetchOptions()
  },
  // watch: {
  //   'sorter': {
  //     deep: true,
  //     handler() {
  //       this.update()
  //     }
  //   },
  //   'editPriceModal.form.salePrice'(val) {
  //     const prc = parseFloat(val)
  //     if (prc > 0) {
  //       return
  //     }

  //     if (!this.editPriceModal.form.salePriceStatus) {
  //       return
  //     }

  //     this.editPriceModal.form.salePriceStatus = false
  //   },
  //   'editPriceModal.form.cashDiscount'(val) {
  //     if (!this.editPriceModal.form.cashDiscountStatus) {
  //       return
  //     }

  //     const prc = parseFloat(val)
  //     this.editPriceModal.form.salePrice = prc + (prc * 0.03)
  //   },
  //   'editPriceModal.form.cashDiscountStatus'(val) {
  //     if (!val) {
  //       return
  //     }

  //     const prc = this.editPriceModal.form.cashDiscount
  //     if (prc) {
  //       this.editPriceModal.form.salePrice = prc + (prc * 0.03)
  //     } else {
  //       this.editPriceModal.form.salePrice = 0
  //     }
  //   }
  // },
  computed: {
    // ...mapState('sales/report/lowPriceAlert', {
    //   items: 'aggregate',
    //   pagination: 'pagination'
    // }),
    ...mapGetters('sales/printer', [
      'order',
      // 'vendors',
      // 'vendorOptions',
      // 'vendorProfitCalculationTargets',
      'isRequestingServer',
      // 'isPaginationApplicable',
      // 'categoryOptions'
    ]),
    // isLayoutCompact() {
    //   return 'compact' === this.layout
    // },
    // isLayoutHorizontal() {
    //   return 'horizontal' === this.layout
    // },
    // isLayoutVertical() {
    //   return 'vertical' === this.layout
    // },
    // isOldProductLinkToUse() {
    //   return 'old' === this.productLinkToUse
    // },
    // isNewProductLinkToUse() {
    //   return 'new' === this.productLinkToUse
    // },
    // isSalePriceEmpty() {
    //   return !parseFloat(this.editPriceModal.form.salePrice)
    // },
    orderNumber() {
      return _.get(this.order, 'order_number')
    },
    fetchingData() {
      return this.isRequestingServer
    },
    isFormClear() {
      return _.includes([undefined, null, '', 0], this.filter.orderNumber)
      // return 'all' === this.filter.vendor
      //   && _.includes([undefined, null, '', 0], this.filter.productId)
      //   && _.includes([undefined, null, '', 0], this.filter.categoryId)
    },
    // hasItem() {
    //   return !!_.size(this.items)
    // }
  },
  methods: {
    loadFilterFromRoute() {
      const orderNumber = this.$route.query.orderNumber
      if (undefined !== orderNumber) {
        this.filter.orderNumber = orderNumber
        this.$store.dispatch('sales/printer/filterByOrderNumber', orderNumber)
      }
      // const productId = this.$route.query.productId
      // if (undefined !== productId) {
      //   this.filter.productId = productId
      //   this.$store.dispatch('sales/report/lowPriceAlert/filterByProductId', productId)
      // }
      // const fromVendor = this.$route.query.fromVendor
      // if (undefined !== fromVendor) {
      //   this.filter.vendor = fromVendor
      //   this.$store.dispatch('sales/report/lowPriceAlert/showProductsFromVendor', fromVendor)
      // }
      // const categoryId = this.$route.query.categoryId
      // if (undefined !== categoryId) {
      //   this.filter.categoryId = categoryId
      //   this.$store.dispatch('sales/report/lowPriceAlert/filterByCategoryId', categoryId)
      // }
    },
    loadSorterFromRoute() {
      const sortProfitAmount = this.$route.query.sortProfitAmount
      if (undefined !== sortProfitAmount) {
        this.sorter.sortProfitAmount = sortProfitAmount
        this.$store.dispatch('sales/report/lowPriceAlert/sortByProfitAmount', sortProfitAmount)
      }
      const sortProfitPercentage = this.$route.query.sortProfitPercentage
      if (undefined !== sortProfitPercentage) {
        this.sorter.vendor = sortProfitPercentage
        this.$store.dispatch('sales/report/lowPriceAlert/sortByProfitPercentage', sortProfitPercentage)
      }
    },
    // loadPaginationFromRoute() {
    //   const page = parseInt(this.$route.query.page)
    //   if (page && 1 !== page) {
    //     this.$store.dispatch('sales/report/lowPriceAlert/changePage', page)
    //   }
    //   const perPage = parseInt(this.$route.query.perPage)
    //   if (perPage && 10 !== perPage) {
    //     this.$store.dispatch('sales/report/lowPriceAlert/changeItemsPerPage', perPage)
    //   }
    // },
    // openPage(page) {
    //   this.$store.dispatch('sales/report/lowPriceAlert/changePage', page)

    //   let query = _.assign({}, this.$route.query, {page: page})
    //   if (query.page && 1 == query.page) {
    //     delete query.page
    //   }
    //   if (query.itemsPerPage && 10 == query.itemsPerPage) {
    //     delete query.itemsPerPage
    //   }

    //   this.$router.push({
    //     name   : this.$route.name,
    //     params : _.assign({}, this.$route.params),
    //     query  : query,
    //   })

    //   this.fetchOrder()
    // },
    // calculateProfitMargin(forVendor) {
    //   this.$store.dispatch('sales/report/lowPriceAlert/calculateProfitMargin', forVendor)

    //   let query = _.assign({}, this.$route.query, {profitMarginTarget: forVendor})
    //   if (query.profitMarginTarget && 'all' == query.profitMarginTarget) {
    //     delete query.profitMarginTarget
    //   }

    //   this.$router.push({
    //     name   : this.$route.name,
    //     params : _.assign({}, this.$route.params),
    //     query  : query,
    //   })

    //   this.fetchOrder()
    // },
    // showProductsFromVendor(fromVendor) {
    //   this.$store.dispatch('sales/report/lowPriceAlert/showProductsFromVendor', fromVendor)

    //   let query = _.assign({}, this.$route.query, {fromVendor: fromVendor})
    //   if (query.fromVendor && 'all' == query.fromVendor) {
    //     delete query.fromVendor
    //   }

    //   this.$router.push({
    //     name   : this.$route.name,
    //     params : _.assign({}, this.$route.params),
    //     query  : query,
    //   })

    //   this.fetchOrder()
    // },
    // filterByProductId(productId) {
    //   this.$store.dispatch('sales/report/lowPriceAlert/filterByProductId', productId)

    //   let query = _.assign({}, this.$route.query, {productId: productId})
    //   if (query.productId && 'all' == query.productId) {
    //     delete query.productId
    //   }

    //   this.$router.push({
    //     name   : this.$route.name,
    //     params : _.assign({}, this.$route.params),
    //     query  : query,
    //   })

    //   this.fetchOrder()
    // },
    activateTab(name) {
      this.activeTab = name
      // this.storeActiveTab()
    },
    isTabActive(name) {
      return name === this.activeTab
    },
    reload() {
      this.fetchOrder()
      // this.fetchOptions()
    },
    clear() {
      // this.filter.vendor = 'all'
      // this.filter.productId = null
      // this.filter.categoryId = null
      this.filter.orderNumber = null
      this.update()
    },
    update() {
      this.$store.dispatch('sales/printer/filterByOrderNumber', this.filter.orderNumber)
      // this.$store.dispatch('sales/report/lowPriceAlert/showProductsFromVendor', this.filter.vendor)
      // this.$store.dispatch('sales/report/lowPriceAlert/filterByProductId', this.filter.productId)
      // this.$store.dispatch('sales/report/lowPriceAlert/filterByCategoryId', this.filter.categoryId)
      // this.$store.dispatch('sales/report/lowPriceAlert/sortByProfitAmount', this.sorter.profitAmount)
      // this.$store.dispatch('sales/report/lowPriceAlert/sortByProfitPercentage', this.sorter.profitPercentage)
      // this.$store.dispatch('sales/report/lowPriceAlert/changePage', 1)

      let query = _.assign({}, this.$route.query, {
        orderNumber : this.filter.orderNumber,
        // fromVendor : this.filter.vendor,
        // productId  : this.filter.productId,
        // categoryId : this.filter.categoryId,
        // 'so-pa'    : this.sorter.profitAmount,
        // 'so-pp'    : this.sorter.profitPercentage,
      })
      if (query.orderNumber && '' == query.orderNumber) {
        delete query.orderNumber
      }
      // if (query.fromVendor && 'all' == query.fromVendor) {
      //   delete query.fromVendor
      // }
      // if (_.has(query, 'productId') && _.includes([null, '', 'all'], query.productId)) {
      //   delete query.productId
      // }
      // if (_.has(query, 'categoryId') && _.includes([null, ''], query.categoryId)) {
      //   delete query.categoryId
      // }
      // if (_.has(query, 'so-pa') && _.includes([null, ''], query['so-pa'])) {
      //   delete query['so-pa']
      // }
      // if (_.has(query, 'so-pp') && _.includes([null, ''], query['so-pp'])) {
      //   delete query['so-pp']
      // }
      // if (query.page) {
      //   delete query.page
      // }

      this.$router.push({
        name   : this.$route.name,
        params : _.assign({}, this.$route.params),
        query  : query,
      })

      this.fetchOrder()
    },
    fetchOrder() {
      this.$store.dispatch('sales/printer/fetchOrder')
    },
    // fetchOptions() {
    //   this.$store.dispatch('sales/report/lowPriceAlert/fetchOptions')
    // },
    // isRowActive(row) {
    //   return this.activeRow === row
    // },
    // setRowAsActive(row) {
    //   this.activeRow = row
    // },
    // lastDateFormat(lastDate) {
    //   if (!lastDate) {
    //     return null
    //   }
    //   if ('0000-00-00 00:00:00' === lastDate) {
    //     return null
    //   }

    //   return moment(new Date(lastDate)).format('YYYYMMDD')
    // },
    // productLink(item, part) {
    //   if (this.isOldProductLinkToUse) {
    //     return `/admin/categories.php?pID=${part.details.productId}&action=new_product`
    //   }
    //   if (this.isNewProductLinkToUse) {
    //     return `/admin/product/view/${part.details.productId}`
    //   }
    // },
    // vendorLink(item, part) {
    //   return `/admin/manufacturers.php?mID=${part.details.vendorId}&action=view`
    // },
  },
  // components: {
  //   Modal,
  //   Money,
  //   Pagination,
  //   Toggle
  // },
  directives: {
    popover: Popover,
    tooltip: Tooltip
  },
  // filters: {
  //   normalizePartNumber: NormalizePartNumber,
  //   dateFormat: DateFormat,
  // },
  mixins: [
    ApiResponseMixin,
    // MoneyMixin
  ]
}
</script>
